var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-flag",class:{ 'no-shadow': _vm.code === 'ww' }},[_c('nuxt-resource',{attrs:{"lazy":_vm.lazy,"src":`images/flags/${_vm.code.toLowerCase()}.svg`,"alt":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }